export const ID = 'YIIZVRP109'
export const KEY = 'b9d3ce281a8e35366a7c694b72be2c9e'

export const KEYWRITE = '95ec95b3ba53996b43560b9f234418c3'